import React from "react";
import { Box, Card, CardContent, Divider, Typography, useTheme } from "@mui/material";
import { VideoPreviewV2 } from "../../../components/video/VideoPreviewV2";
import { VideoData } from "../../../shared/interfaces/VideoData";
import { cardStyles, cardContentStyles, sectionHeaderStyles } from "../styles";
import { VideoNavigationControls } from "./VideoNavigationControls";

interface Props {
  videoData: VideoData;
  videoDataListLength: number;
  currentPage: number;
  viewedVideos: Set<number>;
  handlePageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  handlePrevVideo: () => void;
  handleNextVideo: () => void;
}

export const VideoEvidenceSection: React.FC<Props> = ({
  videoData,
  videoDataListLength,
  currentPage,
  viewedVideos,
  handlePageChange,
  handlePrevVideo,
  handleNextVideo,
}) => {
  const theme = useTheme();

  return (
    <Card {...cardStyles(theme)}>
      <CardContent {...cardContentStyles}>
        <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: "50%",
              bgcolor: theme.palette.primary.main,
              color: "white",
              fontWeight: 700,
              fontSize: "1rem",
              flexShrink: 0,
            }}
          >
            1
          </Box>
          <Typography {...sectionHeaderStyles(theme)}>Review Video Evidence</Typography>
        </Box>
        <Divider sx={{ mb: 3 }} />

        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", mb: 2 }}>
          <VideoPreviewV2 videoData={videoData} isMinimized={false} isMinimizable={false} />

          {videoDataListLength > 1 && (
            <Box sx={{ mt: 3, pt: 3, borderTop: `1px solid ${theme.palette.divider}` }}>
              <VideoNavigationControls
                videoDataListLength={videoDataListLength}
                currentPage={currentPage}
                viewedVideos={viewedVideos}
                handlePageChange={handlePageChange}
                handlePrevVideo={handlePrevVideo}
                handleNextVideo={handleNextVideo}
              />
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};
